"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableActionBar = void 0;

var _react = _interopRequireDefault(require("react"));

var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles/makeStyles.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useStyles = (0, _makeStyles.default)({
  root: {
    margin: '0 0 14px 0',
    fontFamily: 'Oswald',
    borderRadius: 4,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    '& h2': {
      textTransform: 'uppercase',
      margin: '0 0 11px 0',
      fontWeight: 500,
      fontSize: 22
    }
  }
});

var TableActionBar = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var title = props.title,
      className = props.className,
      onRender = props.onRender;

  var _useStyles = useStyles(),
      root = _useStyles.root;

  var onRenderReturn = onRender === null || onRender === void 0 ? void 0 : onRender();
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: ref,
    className: "".concat(root, " ").concat(className)
  }, /*#__PURE__*/_react.default.createElement("h2", null, title), onRenderReturn !== null && onRenderReturn !== void 0 ? onRenderReturn : null);
});

exports.TableActionBar = TableActionBar;